import { readonly, ref, shallowReadonly, shallowRef } from 'vue';

import { getWorkingPlatformMemberships, type PlatformUserRowFieldsFragment } from '@/entities/platform';
import { useToast } from '@/shared/lib';

import { useImpersonation } from './use-impersonation';

export const useImpersonationEntry = () => {
  const { isStarting, start } = useImpersonation();
  const toast = useToast();
  const dialogUser = shallowRef<PlatformUserRowFieldsFragment | null>(null);
  const preferredOrganizationId = ref<string | null>(null);

  const closeDialog = (): void => {
    dialogUser.value = null;
    preferredOrganizationId.value = null;
  };

  const begin = async (user: PlatformUserRowFieldsFragment, organizationId: string | null = null): Promise<void> => {
    const activeMemberships = getWorkingPlatformMemberships(user);

    if (activeMemberships.length === 0) {
      toast.error('У пользователя нет активного трудоустройства.');

      return;
    }

    if (activeMemberships.length === 1) {
      await start({
        targetUserId: user.user.id,
        organizationId: activeMemberships[0]!.organization.id,
      });

      return;
    }

    dialogUser.value = user;
    preferredOrganizationId.value = activeMemberships.some(({ organization }) => organization.id === organizationId)
      ? organizationId
      : null;
  };

  return {
    dialogUser: shallowReadonly(dialogUser),
    preferredOrganizationId: readonly(preferredOrganizationId),
    isStarting,
    begin,
    closeDialog,
  };
};
